import { type HomeHealthAlertRow } from "./types";

// Labels, alert keys, and tooltip copy mirror the Figma exactly — do not paraphrase.
export const HOME_HEALTH_ALERT_ROWS: readonly HomeHealthAlertRow[] = [
  {
    label: "Chat messages",
    alertKey: "chatMessages",
    tooltip: "Notifications when a clinician messages you through Clipboard",
    smsAlertKey: "chatMessages",
  },
  {
    label: "Visit Pended",
    alertKey: "visitPendedEmail",
    tooltip: "Notifications when a clinician marks a booked visit as pending",
  },
  {
    label: "Visit Confirmed",
    alertKey: "visitConfirmedEmail",
    tooltip: "Notifications when a clinician shares their first visit date",
  },
  {
    label: "Visit logged",
    alertKey: "visitLoggedEmail",
    tooltip: "Notifications when a clinician logs a visit",
  },
  {
    label: "Worker unassigned from visit",
    alertKey: "visitUnassignedWorkplaceEmail",
    tooltip: "Notifications when a clinician cancels or is removed from a visit",
  },
  {
    label: "Visit verification reminder",
    alertKey: "visitVerificationReminderEmail",
    tooltip: "Reminder to verify outstanding visits",
  },
] as const;

export const ALL_NOTIFICATIONS_LABEL = "All notifications";

// Master toggle's alertKey within a channel (EMAIL or SMS). Writing
// { enabled: false } here maps to Knock's channel-level mute
// (NotificationPreferences.channelTypes.email / .sms), suppressing every
// workflow on that channel for the user across every workplace.
export const MASTER_ALERT_KEY = "All";
